import { useDirection, useProperty, useTranslation } from '@eti/providers';
import { Inline, Stack, Text } from '@etg/wings';
import { Share } from '@phosphor-icons/react';
import TopicsContentWrapper from '../TopicsContentWrapper';
import FaqSection from '../../common/FaqSection';
import { useOrderDetails } from '../../../containers/OrderDetailsContext';

const CantFindMyAnswer = () => {
  const { t } = useTranslation();
  const { p } = useProperty();
  const { isRTL } = useDirection();
  const { faqSectionPerSlug } = useOrderDetails();
  const faqSectionSlug = p('ContactUs.MoreQuestions.Faq.Slug');

  return (
    <TopicsContentWrapper
      chatType="genesys"
      leftColumnContent={
        <Stack spacing={24}>
          <Text>{t('ContactUs.Subtopic.CantFindMyAnswer.Content')}</Text>
          <a
            aria-label={`${t('ContactUs.Subtopic.CantFindMyAnswer.FAQ.Link.Text')}, ${t(
              'ScreenReader.Link.OpensInNewTab.AriaLabel.Text',
            )}`}
            data-testid="cant-find-my-answer-link-faq"
            href={t('ContactUs.FAQ.ButtonLink')}
            rel="noreferrer"
            target="_blank"
          >
            <Inline alignY="center" spacing={8}>
              <Text>{t('ContactUs.Subtopic.CantFindMyAnswer.FAQ.Link.Text')}</Text>
              <Share aria-hidden="true" mirrored={isRTL} size={20} />
            </Inline>
          </a>
          {faqSectionPerSlug?.[faqSectionSlug] && (
            <FaqSection
              headingAs="h5"
              headingLevel={4}
              padding={0}
              section={faqSectionPerSlug[faqSectionSlug]}
            />
          )}
        </Stack>
      }
      snowplowProperty="MORE_QUESTIONS"
    />
  );
};

export default CantFindMyAnswer;
